import React, { useState } from "react";
import {
    TextField,
    Button,
    CircularProgress,
    IconButton,
    InputAdornment,
    OutlinedInput,
    InputLabel,
    FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Autocomplete,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { setSuccess } from "../../../Redux/AlertReducer";
import { useDispatch } from "react-redux";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { errorToaster } from "../../../helper/toasterConfiguration";

export const FormAddMembershipService = ({
                                             groups,
                                             isGroupsLoading,
                                         }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
    const [selectedGroup, setSelectedGroup] = useState([]);
    const itemsPerPage = 25;
    const [groupsPage, setGroupsPage] = useState(1);
    const [groupSearchQuery, setGroupSearchQuery] = useState("");
    const paginatedGroups = groups.slice(0, groupsPage * itemsPerPage);
    const filteredGroups = groups.filter((Group) =>
        Group.name.toLowerCase().includes(groupSearchQuery.toLowerCase())
    );
    const displayedGroups = groupSearchQuery
        ? filteredGroups
        : paginatedGroups;



  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [data, setData] = useState({
    title: "",
    description:"",
    is_active:true,
    all:false,
    count:0,
      groups: []
  });

    const handleGroupChange = (event, newValue) => {
        setSelectedGroup(newValue);
        // Extract only Group IDs
        const GroupIds = newValue.map(Group => Group.id);
        setData(prev => ({ ...prev, groups: GroupIds }));
    };

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();


    setIsLoadingSubmit(true);

    const formDataToSend = new FormData();

    formDataToSend.append('title', data.title);
    formDataToSend.append('description', data.description);
    formDataToSend.append('is_active', data.is_active ? 1 : 0);
    formDataToSend.append('all', data.all ? 1 : 0);
    formDataToSend.append('count', data.count);

      data.groups.forEach(GroupId => {
          formDataToSend.append('groups[]', GroupId);
      });

    try {
      const { result, response, message } = await Helper.Post({
        url: api_Routes.MembershipService.Add,
        data: formDataToSend,
        isFormData: true,
        showErrors: ["title"],
      });

      setIsLoadingSubmit(false);
      if (response) {
        dispatch(setSuccess(true));
        navigate("/Membership-Services");
      } 
    } catch (error) {
      console.error("An error occurred during form submission:", error);
      setIsLoadingSubmit(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-4">

        <TextField
          fullWidth
          margin="normal"
          label="Title"
          name="title"
          required
          type="title"
          autoComplete="off"
          value={data.title}
          onChange={handleInputChange}
          variant="outlined"
        />
        <TextField
          fullWidth
          margin="normal"
          label="Count"
          name="count"
          type="number"
          autoComplete="off"
          value={data.count}
          onChange={handleInputChange}
          variant="outlined"
        />
        <TextField
          fullWidth
          margin="normal"
          label="Description"
          name="description"
          type="description"
          multiline
          rows={2}
          autoComplete="off"
          value={data.description}
          onChange={handleInputChange}
          variant="outlined"
        />
      </div>

        <div className="w-full">
            <Autocomplete
                multiple
                disablePortal
                loading={isGroupsLoading}
                options={displayedGroups}
                getOptionLabel={(option) => option.name || ""}
                onChange={handleGroupChange}
                onInputChange={(event, value) => setGroupSearchQuery(value)}
                renderInput={(params) => (
                    <TextField {...params} label="Group" variant="outlined"/>
                )}
                ListboxProps={{
                    onScroll: (event) => {
                        const listboxNode = event.currentTarget;
                        if (
                            listboxNode.scrollTop + listboxNode.clientHeight >=
                            listboxNode.scrollHeight - 3
                        ) {
                            setGroupsPage((prevPage) => prevPage + 1);
                        }
                    },
                }}
            />
        </div>


      <div className="w-full flex items-center justify-start gap-x-3">
        <FormLabel sx={{ fontWeight: "bold" }} component="legend">
          Active:
        </FormLabel>
        <RadioGroup
            name="is_active"
            value={data.is_active.toString()}
            onChange={(e) => {
              const value = e.target.value === 'true';
              setData(prev => ({ ...prev, is_active: value }));
            }}
            row
        >
          <FormControlLabel value="true" control={<Radio />} label="Yes" />
          <FormControlLabel value="false" control={<Radio />} label="No" />
        </RadioGroup>
      </div>
      <div className="w-full flex items-center justify-start gap-x-3">
        <FormLabel sx={{ fontWeight: "bold" }} component="legend">
          All:
        </FormLabel>
        <RadioGroup
            name="all"
            value={data.all.toString()}
            onChange={(e) => {
              const value = e.target.value === 'true';
              setData(prev => ({ ...prev, all: value }));
            }}
            row
        >
          <FormControlLabel value="true" control={<Radio />} label="Yes" />
          <FormControlLabel value="false" control={<Radio />} label="No" />
        </RadioGroup>
      </div>
      {errorMessage && (
        <div className="w-full text-start text-red-600">*{errorMessage}</div>
      )}

      <Button
        type="submit"
        fullWidth
        variant="contained"
        disabled={isLoadingSubmit || errorMessage}
        color="primary"
        sx={{
          display: isLoadingSubmit ? "flex" : "block",
          marginTop: 2,
          width: "20%",
          marginX: "auto",
          fontWeight: "bold",
          justifyContent: "center",
        }}
      >
        {isLoadingSubmit ? (
          <CircularProgress size={24} color="primary" />
        ) : (
          "Submit"
        )}
      </Button>
    </form>
  );
};
